// import React, { useState, useEffect } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import moment from 'moment';
// import PropTypes from 'prop-types';

// import { useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
// import Box from '@material-ui/core/Box';

// import { members, deposit, chargeBonus } from 'lib/api/member';
// import { makeRowColumn, getHeadObj, getDate } from 'lib/commonLib';

// import FilterWrap from 'components/atoms/FilterWrap';
// import MbTooltip from 'components/atoms/MbTooltip';
// import OutlinedButton from 'components/atoms/OutlinedButton';
// import MbSwitch from 'components/atoms/MbSwitch';
// import MbButton from 'components/atoms/MbButton';
// import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
// import MbRadioGroup from 'components/molecules/MbRadioGroup';
import NewRadioGroup from 'components/molecules/NewRadioGroup';

import FilterCollection from 'components/organisms/FilterCollection';

const usersStyles = makeStyles((theme) => ({
  filterWrap: {
    padding: '10px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > :not(:first-child)': { marginTop: 10 },
  },
  btnWrap: { width: '100%', '& > div': { marginBottom: 10 } },
  allBtnWrap: {
    width: '100%',
    backgroundColor: '#f6f6f9',
    '&  button:hover ': { backgroundColor: theme.palette.common.green },
    '& > div': { marginBottom: 10 },
  },
  submitBtnWrap: {
    width: '100%',
    backgroundColor: theme.palette.common.green,
    color: '#fff',
    '&  button:hover ': { backgroundColor: theme.palette.common.green },
    '& > div': { marginBottom: 10 },
  },
  input: {
    height: 32,
    width: '130px !important',
    fontSize: 14,
    '& input': { textAlign: 'right' },
  },
  button: {
    width: '100%',
    borderColor: theme.palette.box.secondaryBorderColor,
    height: 32,
    fontSize: 14,
    lineHeight: `14px`,
    '&.all': { backgroundColor: '#f6f6f9' },
  },
}));

const NewRemainingAmountFilter = (props) => {
  const { params, getParam, disabled } = props;
  const classes = usersStyles();
  const { t } = useTranslation();

  const [openParams, setOpenParams] = useState({
    open: false,
  });

  const [filterFlag, setFilterFlag] = useState(true);

  const useHandleParams = (newParams) => {
    let tempParams = { ...newParams };
    if (tempParams['open']) {
      // 잔여금액 사용
      tempParams['sPoint'] = '';
      tempParams['ePoint'] = '';
    } else {
      delete tempParams['sPoint'];
      delete tempParams['ePoint'];
    }
    setOpenParams(tempParams);
    getParam({ ...params, ...tempParams });
  };

  const handlePoint = (point) => {
    let result = { ...openParams };
    if (point === '5000') {
      result['sPoint'] = '0';
      result['ePoint'] = '5000';
    } else if (point === '10000') {
      result['sPoint'] = '5000';
      result['ePoint'] = '10000';
    } else if (point === '50000') {
      result['sPoint'] = '10000';
      result['ePoint'] = '50000';
    } else if (point === '100000') {
      result['sPoint'] = '50000';
      result['ePoint'] = '100000';
    } else if (point === '0') {
      result['sPoint'] = '100000';
      result['ePoint'] = '0';
    }

    setOpenParams(result);
  };

  const handleSubmit = () => {
    let tempParams = { ...openParams };
    if (openParams['open']) {
      // 잔여금액 사용
      tempParams['sPoint'] = openParams['sPoint'];
      tempParams['ePoint'] = openParams['ePoint'];
    } else {
      // 잔여금 미사용
      delete tempParams['sPoint'];
      delete tempParams['ePoint'];
    }
    setOpenParams({ ...tempParams });
    getParam({ ...params, ...tempParams });
    setFilterFlag(false);
  };
  return (
    <>
      <FilterCollection
        open={filterFlag}
        label={t('잔여금액')}
        filtered={params.sPoint}        
        disabled={disabled}
        selectLabel={
          !!params.ePoint
            ? params.ePoint === '5000'
              ? '0 ~ 5,000'
              : params.ePoint === '10000'
              ? '5,000 ~ 10,000'
              : params.ePoint === '50000'
              ? '10,000 ~ 50,000'
              : params.ePoint === '100000'
              ? '50,000 ~ 100,000'
              : params.ePoint === '0' && '100,000 ~ '
            : ''
        }
        popoverHeight={470}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '5px 0',
          }}
        >
          <NewRadioGroup
            params={openParams}
            labelKey="label"
            valueKey="value"
            optionList={[
              { label: '사용 ', value: true },
              { label: '미사용 ', value: false },
            ]}
            handleGetValue={useHandleParams}
            name="open"
            style={{ height: 30 }}
          />
        </div>
        {openParams.open && (
          <>
            <div className={classes.filterWrap}>
              {/*<div className={classes.userInput}>*/}
              {/*  <NewInput*/}
              {/*    placeholder={t('최소금액')}*/}
              {/*    type="filter"*/}
              {/*    name="sPoint"*/}
              {/*    params={params}*/}
              {/*    value={params['sPoint']}*/}
              {/*    callBack={getParam}*/}
              {/*    className={classes.input}*/}
              {/*  />*/}
              {/*  <span className={classes.margin6}>-</span>*/}
              {/*  <NewInput*/}
              {/*    placeholder={t('최고금액')}*/}
              {/*    type="filter"*/}
              {/*    name="ePoint"*/}
              {/*    params={params}*/}
              {/*    value={params['ePoint']}*/}
              {/*    callBack={getParam}*/}
              {/*    className={classes.input}*/}
              {/*  />*/}
              {/*</div>*/}
              {/*{!noneAllBtn && (*/}
              {/*  <Button*/}
              {/*    className={`${classes.button} all`}*/}
              {/*    variant="outlined"*/}
              {/*    onClick={handleButonClick('all')}*/}
              {/*  >*/}
              {/*    {t('전체')}*/}
              {/*  </Button>*/}
              {/*)}*/}
              <div className={classes.btnWrap}>
                <NewButton
                  title={t('0 ~ 5,000')}
                  disableRipple
                  className={classes.button}
                  onClick={() => handlePoint('5000')}
                  style={
                    openParams['ePoint'] === '5000'
                      ? { backgroundColor: '#79bd2f', color: '#fff' }
                      : {}
                  }
                >
                  0 ~ 5,000
                </NewButton>
                <NewButton
                  title={t('5,000 ~ 10,000')}
                  disableRipple
                  className={classes.button}
                  onClick={() => handlePoint('10000')}
                  style={
                    openParams['ePoint'] === '10000'
                      ? { backgroundColor: '#79bd2f', color: '#fff' }
                      : {}
                  }
                >
                  5,000 ~ 10,000
                </NewButton>
                <NewButton
                  title={t('10,000 ~ 50,000')}
                  disableRipple
                  className={classes.button}
                  onClick={() => handlePoint('50000')}
                  style={
                    openParams['ePoint'] === '50000'
                      ? { backgroundColor: '#79bd2f', color: '#fff' }
                      : {}
                  }
                >
                  10,000 ~ 50,000
                </NewButton>
                <NewButton
                  title={t('50,000 ~ 100,000')}
                  disableRipple
                  className={classes.button}
                  onClick={() => handlePoint('100000')}
                  style={
                    openParams['ePoint'] === '100000'
                      ? { backgroundColor: '#79bd2f', color: '#fff' }
                      : {}
                  }
                >
                  50,000 ~ 100,000
                </NewButton>
                <NewButton
                  title={t('이상', { value: '100,000' })}
                  disableRipple
                  className={classes.button}
                  onClick={() => handlePoint('0')}
                  style={
                    openParams['ePoint'] === '0'
                      ? { backgroundColor: '#79bd2f', color: '#fff' }
                      : {}
                  }
                >
                  {t('이상', { value: '100,000' })}
                </NewButton>
              </div>
              <div style={{ width: '100%' }}>
                <NewButton
                  title={t('확인')}
                  disableRipple
                  className={classes.submitBtnWrap}
                  onClick={handleSubmit}
                >
                  확인
                </NewButton>
              </div>
            </div>
          </>
        )}
      </FilterCollection>
    </>
  );
};

export default NewRemainingAmountFilter;
